{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "您的角色不允许您{action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "您的角色不允许您执行此操作",
    "mustHaveAtLeast8Characters": "至少包含 8 个字符",
    "mustContainUpperCaseAndLowerCase": "必须包含大写和小写字母",
    "mustContainAtLeastOneLetter": "必须包含至少一个字母",
    "mustContainAtLeastOneSpecialCharacter": "必须包含至少一个特殊字符",
    "mustContainAtLeastOneNumber": "必须包含至少一个数字"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "拥有所有权限，并完全控制所有账户。",
    "godRoleWithLessControl": "控制权较少的 GOD 角色。",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "拥有所有权限，并完全控制组织账户。",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "创建/编辑/删除预约、仓库、货物类型、站台和用户（所有者除外）。",
    "createEditCancelAppointments": "创建/编辑/取消预约。",
    "editAppointmentStatusTagsAndSubscribers": "编辑预约状态、标签和订阅者。",
    "viewOnlyNoCreateOrEditActionsAllowed": "仅可查看，不允许创建或编辑。",
    "carrierAdministrator": "承运商管理员。",
    "carrierUser": "承运商用户",
    "baseUserAccount": "基础用户账户。",
    "warehouseDriverHasLimitedAccessToTheApplication": "仓库司机，对应用的访问权限有限。"
  }
}
